import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c849892"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-item__content" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "custom-item__content__edit"
}
const _hoisted_4 = { class: "custom-item__content-name" }
const _hoisted_5 = {
  key: 1,
  class: "custom-item__content__edit"
}
const _hoisted_6 = {
  key: 2,
  class: "custom-item__content__tags"
}

import { nextTick, PropType, ref } from 'vue'
import usePreference from '@teams/common/hooks/usePreference'
import { useH5PreviewPreference } from '@/views/home/preview/hooks'
import { InputInst, NDropdown, NInput, useMessage } from 'naive-ui'
import { ICaseItem } from '../pcCustom.vue'
import useAppDialog from '@/components/appDialog/useAppDialog'
import commonConfirmDialog from '@/components/dialog/commonConfirmDialog.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'customCaseItem',
  props: {
  item: {
    type: Object as PropType<ICaseItem>,
    required: true
  },
  selectedFlag: {
    type: Boolean,
    required: true
  }
},
  emits: [
  'handleCreateNewTheme',
  'refreThemeList',
  'updateCurrentItem'
],
  setup(__props, { emit: emits }) {

const props = __props



const { createCustomTheme, changeCurrentThemeName, deleteTheme } =
  usePreference()
const h5PreviewPreference = useH5PreviewPreference()
const appDialog = useAppDialog()
const message = useMessage()
const createThemeOptions = [
  {
    label: '基于此新建主题',
    key: 'createNewThemeBaseThis'
  }
]
const customThemeOptions = [
  {
    label: '重命名',
    key: 'rename'
  },
  {
    label: '编辑主题',
    key: 'editeTheme'
  },
  {
    label: '删除主题',
    key: 'deleteTheme'
  }
]
const MAX_LENGTH = 500
const xRef = ref(0)
const yRef = ref(0)
const isShowDropdown = ref(false)
const isShowEdit = ref(false)
const inputValue = ref(props.item.name)
const propsItem = ref(props.item)
const inputInstRef = ref<InputInst | null>(null)

const updateIsshowDropdown = (val: boolean) => {
  isShowDropdown.value = val
}
// 右键弹窗
const handleContextMenu = (e: MouseEvent) => {
  e.preventDefault()
  updateIsshowDropdown(false)
  nextTick().then(() => {
    updateIsshowDropdown(true)
    xRef.value = e.clientX
    yRef.value = e.clientY
  })
  emits('updateCurrentItem', propsItem.value)
}
const onClickoutside = () => {
  updateIsshowDropdown(false)
}
// 新建主题
const createNewTheme = () => {
  createCustomTheme({ extendsName: props.item.key })
  h5PreviewPreference.syncH5PreferenceStore()
  emits('handleCreateNewTheme')
}
// 重命名
const confirmEdit = () => {
  if (!inputValue.value.trim()) {
    message.warning('输入名称不能为空')
    return
  }
  if (inputValue.value.length > MAX_LENGTH) {
    message.warning(`输入名称超出最大字符500${MAX_LENGTH}`)
    return
  }
  changeCurrentThemeName(inputValue.value)
  isShowEdit.value = false
  propsItem.value.name = inputValue.value
  emits('updateCurrentItem', propsItem.value)
}
// 删除主题
const onDeleteTheme = () => {
  // deleteTheme(props.item.key)
  appDialog.show({
    component: commonConfirmDialog,
    title: '是否删除',
    componentProps: {
      content: '是否删除该主题？',
      confirmButtonText: '确认',
      onOK: () => {
        deleteTheme(props.item.key)
        emits('refreThemeList', props.item.key) // 删除后，刷新列表
      }
    },
    footer: false,
    modalProps: {
      style: {
        width: '480px'
      }
    }
  })
}
// 处理选择项函数
const handleSelect = (key: string) => {
  switch (key) {
    case 'createNewThemeBaseThis':
      updateIsshowDropdown(false)
      createNewTheme()
      break
    case 'rename':
      updateIsshowDropdown(false)
      isShowEdit.value = true
      nextTick().then(() => {
        inputInstRef.value?.select()
      })
      break
    case 'editeTheme':
      updateIsshowDropdown(false)
      emits('handleCreateNewTheme')
      break
    case 'deleteTheme':
      updateIsshowDropdown(false)
      onDeleteTheme() // 删除自定义主题
      break
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onContextmenu: handleContextMenu,
    class: _normalizeClass(["custom-item__content-wrap", __props.selectedFlag ? 'custom-item__content-active' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: __props.item.img,
        alt: "custom-image"
      }, null, 8, _hoisted_2),
      (!isShowEdit.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(inputValue.value), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(NInput), {
              type: "text",
              size: "tiny",
              placeholder: inputValue.value,
              value: inputValue.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
              autofocus: true,
              ref_key: "inputInstRef",
              ref: inputInstRef,
              onKeydown: _withKeys(confirmEdit, ["enter"]),
              onBlur: confirmEdit
            }, null, 8, ["placeholder", "value", "onKeydown"])
          ])),
      (__props.item.official)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(__props.item.official ? '官方' : ''), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NDropdown), {
        placement: "bottom-start",
        trigger: "manual",
        x: xRef.value,
        y: yRef.value,
        options: __props.item.official ? createThemeOptions : customThemeOptions,
        show: isShowDropdown.value,
        "on-clickoutside": onClickoutside,
        onSelect: handleSelect,
        class: "dropdown--default"
      }, null, 8, ["x", "y", "options", "show"])
    ])
  ], 34))
}
}

})